export default __webpack_public_path__ + "static/media/5061264.1ea647cd.png";